import { ScrollView, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';
import { ArrowLeft } from 'lucide-react-native';
import { featureRoutes, type FeatureRouteItem } from '../constants/expoRoutes';
import { FeatureGrid } from '../components/business/FeatureGrid';
import { AppButton } from '../components/ui/AppButton';
import { AppText } from '../components/ui/AppText';
import { tokens } from '../theme/tokens';

export default function AllFunctionsPage() {
  const router = useRouter();

  const openFeature = (feature: FeatureRouteItem) => {
    router.push(feature.href as Parameters<typeof router.push>[0]);
  };

  return (
    <SafeAreaView style={styles.screen}>
      <View style={styles.header}>
        <AppButton
          label="首页"
          variant="ghost"
          onPress={() => router.push('/')}
          leftSlot={<ArrowLeft size={18} color={tokens.colors.primary} />}
          style={styles.backButton}
        />
      </View>

      <ScrollView contentContainerStyle={styles.content}>
        <View style={styles.titleBlock}>
          <AppText variant="title" weight="bold">
            全部功能
          </AppText>
          <AppText variant="body" tone="muted">
            所有功能入口已切换为 Expo Router 路径。
          </AppText>
        </View>
        <FeatureGrid features={featureRoutes} onPressFeature={openFeature} />
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: tokens.colors.background,
  },
  header: {
    paddingHorizontal: tokens.layout.screenPadding,
    paddingTop: tokens.spacing.md,
  },
  backButton: {
    alignSelf: 'flex-start',
    minHeight: 40,
    paddingHorizontal: tokens.spacing.sm,
  },
  content: {
    paddingHorizontal: tokens.layout.screenPadding,
    paddingTop: tokens.spacing.md,
    paddingBottom: tokens.spacing.xxl,
    gap: tokens.spacing.lg,
  },
  titleBlock: {
    gap: tokens.spacing.sm,
  },
});
